/**
 * Convert data from coach API to internal format
 * @param {Object} coach Coach API data
 * @param {Boolean} coach.qualification_bvc Member of _Bundesverband Coaching_
 * @param {Boolean} coach.qualification_bvs Member of _Bundesverband Supervision_
 * @param {Boolean} coach.qualification_other Member of another certified thing
 * @param {String} coach.address Street and number
 * @param {String} coach.avg_rating Rating
 * @param {String} coach.homepage URL of website
 * @param {String} coach.rate Compensation
 * @param {String} coach.telephone Phone number
 * @param {String} coach.mobile Mobile phone number
 * @param {String} coach.text Core area
 * @param {String} coach.town City
 * @param {String} coach.zip_code Postal code
 * @returns {Object} Converted coach data
 */
export default function (coach) {
  return {
    phone: coach.telephone,
    phoneMobile: coach.mobile,
    address: coach.address,
    postalCode: coach.zip_code,
    city: coach.town,
    coreArea: coach.text,
    rating: coach.avg_rating
      ? parseFloat(coach.avg_rating)
      : undefined,
    compensation: parseFloat(coach.rate),
    website: coach.homepage,
    memberships: {
      bvc: {
        name: 'Bundesverband Coaching',
        isMember: coach.qualification_bvc
      },
      bvs: {
        name: 'Bundesverband Supervision',
        isMember: coach.qualification_bvs
      },
      other: {
        name: 'Andere zertifizierte Ausbildung',
        isMember: coach.qualification_other
      }
    }
  }
}
